export default "__VITE_ASSET__BCuz465b__"